<template>
  <base-modal form title="Forfeit Deposit" body-class="is-paddingless">
    <notification class="is-secondary is-radiusless is-marginless">
      Please supply a brief description for forfeiture.
    </notification>
    <div class="columns is-multiline p-2">
      <div class="column is-12">
        <text-area required
          v-model="deposit.forfeit_reason"
          :error="errors.forfeit_reason"
          error-class="has-text-danger">
          Reasoning
        </text-area>
      </div>
    </div>
    <div slot="footer" class="buttons">
      <submit-button
        :working="working"
        @submit="save"
        class="is-success is-rounded">
        Save
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { captureForfeiture } from '@/api/deposit'

export default {

  props: {
    payload: Object
  },

  data:() => ({
    working: false,
    deposit: {}
  }),

  created() {
    this.deposit = { ...this.payload }
  },

  methods: {
    save() {
      this.working = true
      captureForfeiture(this.deposit, () => {
        this.$toast.success('Forfeiture saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }

}
</script>